import { IGroupParentIssuer, IOptionParentIssuer, IParent } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IParent';
import { IIssuer } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IIssuer';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import DateTime from '@dealroadshow/uikit-date-time';

export const getParentOptions = (parents: IParent[]): IOptionParentIssuer[] => {
  return parents.map(({ id, name }) => ({
    label: name,
    value: `${ id }-parent`,
    id,
    isParent: true,
  }));
};

export const getIssuerOptions = (issuers: IIssuer[]): IOptionParentIssuer[] => {
  return issuers.map(({ id, name }) => ({
    label: name,
    value: `${ id }-issuer`,
    id,
    isParent: false,
  }));
};

export const getParentIssuerGroupMapper = (parents: IParent[], issuers: IIssuer[]): IGroupParentIssuer[] => {
  const parentsOptions = getParentOptions(parents);
  const issuersOptions = getIssuerOptions(issuers);

  return [
    {
      label: 'Parents',
      options: parentsOptions,
    },
    {
      label: 'Issuers',
      options: issuersOptions,
    },
  ];
};

export enum EntityType {
  Sector = 'sector',
  Industry = 'industry',
  Region = 'region',
}

const entityFieldsConfig = {
  [EntityType.Sector]: {
    entityId: 'sectorId',
    subentityId: 'subsectorId',
    subentityList: 'subsectorList',
  },
  [EntityType.Industry]: {
    entityId: 'industryId',
    subentityId: 'subindustryId',
    subentityList: 'subindustryList',
  },
  [EntityType.Region]: {
    entityId: 'regionId',
    subentityId: 'countryId',
    subentityList: 'countryList',
  },
};

export const mappingEntityAndSubentity = <T>(
  selectedEntityIds: string[],
  entityList: T[],
  entityType: EntityType,
): [string[], string[]] => {
  const { entityId, subentityList, subentityId } = entityFieldsConfig[entityType];
  const includedIds: string[] = [];
  const includedSubentityIds: string[] = [];

  (selectedEntityIds ?? []).forEach((id) => {
    const currentEntity = (entityList ?? []).find((entity) => entity[entityId] === id);

    if (currentEntity && currentEntity[subentityList]?.length) {
      includedSubentityIds.push(...currentEntity[subentityList].map((subEnity) => subEnity[subentityId]));
    } else {
      includedIds.push(id);
    }
  });

  return [includedIds, includedSubentityIds];
};

export const getDateFromInCurrentTimeZone = (
  isoDate: string,
  timeZone: ITimezone,
): number | null => {
  if (!isoDate) return null;

  return new DateTime(isoDate, { timeZone })
    .getDateWithTimeZoneOffset()
    .setStartOfDay()
    .timestampInSeconds;
};

export const getDateToInCurrentTimeZone = (
  isoDate: string,
  timeZone: ITimezone,
): number | null => {
  if (!isoDate) return null;

  return new DateTime(isoDate, { timeZone })
    .getDateWithTimeZoneOffset()
    .setEndOfDay()
    .timestampInSeconds;
};
